import { MakeLogicType, actions, kea, path, reducers } from 'kea'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface notebookSettingsLogicValues {
    isMarkdownExpanded: boolean
    showKernelInfo: boolean
    showVariablesOverride: boolean | null
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface notebookSettingsLogicActions {
    setIsMarkdownExpanded: (expanded: boolean) => {
        expanded: boolean
    }
    setShowKernelInfo: (showKernelInfo: boolean) => {
        showKernelInfo: boolean
    }
    setShowVariables: (showVariables: boolean | null) => {
        showVariables: boolean | null
    }
}

export type notebookSettingsLogicType = MakeLogicType<notebookSettingsLogicValues, notebookSettingsLogicActions>

// This logic contains settings that should persist across all notebooks
export const notebookSettingsLogic = kea<notebookSettingsLogicType>([
    path(['scenes', 'notebooks', 'notebooks', 'notebookSettingsLogic']),
    actions({
        setIsMarkdownExpanded: (expanded: boolean) => ({ expanded }),
        setShowKernelInfo: (showKernelInfo: boolean) => ({ showKernelInfo }),
        // null restores the default: open when the notebook declares variables, closed when not.
        setShowVariables: (showVariables: boolean | null) => ({ showVariables }),
    }),
    reducers(() => ({
        isMarkdownExpanded: [
            true,
            { persist: true },
            {
                setIsMarkdownExpanded: (_, { expanded }) => expanded,
            },
        ],
        showKernelInfo: [
            false,
            {
                setShowKernelInfo: (_, { showKernelInfo }) => showKernelInfo,
            },
        ],
        showVariablesOverride: [
            null as boolean | null,
            {
                setShowVariables: (_, { showVariables }) => showVariables,
            },
        ],
    })),
])
